export const DEFAULT_API_TIMEOUT = 15000;
export const INDIAN_DIAL_CODE = '+91';
export const SUCCESS_STATUS_CODE = 200;
export const TOAST_AUTOCLOSE = 1800;
export const DEFAULT_TOTAL_PAGES = 1;
export const RECORDS_PER_PAGE = 10;
export const DEFAULT_ACTIVE_PAGE = 1;

export const TOAST_TYPES = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  DEFAULT: 'default'
};

export const ACCESS_LEVELS = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  GOVT: 'GOVERNMENT',
  DISTRICT: 'DISTRICT',
  TALUKA: 'TALUKA'
};

export * from './envVariables';
export * from './routeConstants';
export * from './strings';